// Sentinel stored in goals[i].scorer when the goal was an own goal scored by
// the opposition. The assist (if any) still goes to a real player on our side.
// No penalty applies; the "Own Goal" infraction is separate (our own player).
export const OWN_GOAL_ID = "OWN_GOAL";
export const isOwnGoal = (scorer) => scorer === OWN_GOAL_ID;
